import CarouselBlock from './components/CarouselBlock';
import ImagesBlock from './components/ImagesBlock';
import LatestNewsBlock from './components/LatestNewsBlock';
import PavilionList from './components/PavilionList';

const Blocks = async () =>
    await Promise.all(
        [
            CarouselBlock(),
            ImagesBlock(),
            LatestNewsBlock(),
            PavilionList()
        ]
    );

export default Blocks;
